import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  categoryId: localStorage.getItem('mainCategoryId') ? localStorage.getItem('mainCategoryId') : '',
  subCategoryId: localStorage.getItem('subCategoryId') ? localStorage.getItem('subCategoryId') : '',
  categoryTitle: localStorage.getItem('mainCategoryTitle') ? localStorage.getItem('mainCategoryTitle') : '',
  subCategoryTitle: localStorage.getItem('subCategoryTitle') ? localStorage.getItem('subCategoryTitle') : '',
};

const category = createSlice({
  name: 'id',
  
  initialState,
  reducers: {
    
    setCategoryId: (state, action) => {
      state.categoryId = action.payload;
    },
    setSubCategoryId: (state, action) => {
      state.subCategoryId = action.payload;
    },
    setCategoryTitle: (state, action) => {
      state.categoryTitle = action.payload;
    },
    setSubCategoryTitle: (state, action) => {
      state.subCategoryTitle = action.payload;
    },
  },
});

export const { setCategoryId, setSubCategoryId, setCategoryTitle, setSubCategoryTitle } = category.actions;

// Export the reducer so it can be registered in the single app store
// (redux/slices/login.js). It must NOT create its own store — a second
// store is never wrapped in <Provider>, so dispatches to it are lost.
export default category.reducer;
